import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyFlatList = createAsyncThunk(
  "societyFlatList",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.get(
        `${API_KEY}/api/wing/flat-list/${id}`,

        {
          headers: {
            Authorization: `Barear ${token}`,
          },
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  societyFlatListData: null,
  isError: false,
  errorMessage: "",
};
const societyFlatListSlice = createSlice({
  name: "societyFlatList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyFlatList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyFlatList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyFlatListData = action.payload;
    });
    builder.addCase(societyFlatList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyFlatListSlice.reducer;
